export default __webpack_public_path__ + "34a5f65c5beb690d8d9367656012d8e0.png";